import React, { useEffect, useState } from "react";
import "./Order_details.css";
import Order_id_holder from "./order_id_holder/Order_id_holder";
import Order_details_table from "./order_details_table/Order_details_table";
import Receiver_info_holder from "./receiver_info_holder/Receiver_info_holder";
// import Order_return_Tracking from "../../common-components/order_return_Tracking/Order_return_Tracking";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import Payment_Summary from "../../cart/payment_summary/Payment_Summary";
import Common_Back_Header from "../../common_components/common_back_header/Common_Back_Header";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../features/order/orderSlice";
import { useParams } from "react-router-dom";
import { formatDate } from "../../../utils/common";
import { getNotifications } from "../../../features/notifications/notificationSlice";

function Order_details() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "ORDER DETAILS", link: "", isActive: true },
  ];
  const [showCancelBtn, setShowCancelBtn] = useState();

  const { id } = useParams();
  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    const res = dispatch(getOrder(id));
    if (res.meta?.requestStatus === "fulfilled") {
      setShowCancelBtn(true);
    } else if (res.meta?.requestStatus === "rejected") {
      setShowCancelBtn(false);
    }
  }, [dispatch]);

  const data = {
    total_mrp: order?.total_mrp,
    total_tax: order?.total_tax,
    no_of_item: order?.no_of_item,
    total_selling_price: order?.total_selling_price,
    total_coupon_discount: order?.total_coupon_discount,
    total_offer_discount: order?.total_offer_discount,
    total_amount: order?.total_amount,
    total_delivery_charges: order?.delivery_charges,
    platform_fee: order?.platform_fee,

    payment_method: order?.Payment_Method?.name,
  };

  useEffect(() => {
    // if (user?.id) {
    dispatch(getNotifications());
    // }
  }, []);
  return (
    <>
      <section className="Order_details">
        <div className="container">
          <Common_Back_Header backNavigation="/my-orders" />

          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder
                order={order}
                headingText={`Order ID #${order?.invoice_no}`}
                date={formatDate(order?.createdAt)}
              />

              <Order_details_table order={order} />
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder
                showCancelBtn
                user={order?.User}
                order={order}
                userAddress={order?.User_Address}
                id={order?.id}
              />

              <Payment_Summary data={order} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_details;
